import type { ItemPriority } from '@hugo/core'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { priorityLabel, showsPriority } from '@/lib/priority'
import { priorityTone } from '@/lib/styles'
import { cn } from '@/lib/utils'

/** "↑ High" or "↓ Low" on a row or card; nothing for normal. */
/** `rule`: the rule that set it ("#client"), shown on hover. */
export function PriorityChip({ priority, rule }: { priority: ItemPriority; rule?: string | null }) {
  if (!showsPriority(priority)) return null
  const high = priority === 'high'
  const Icon = high ? ArrowUpIcon : ArrowDownIcon
  return (
    <Badge
      variant="outline"
      className={cn('h-5 px-1.5 font-medium', priorityTone[high ? 'high' : 'low'])}
      data-testid="priority-chip"
      data-priority={priority}
      title={`${priorityLabel(priority)} priority${rule ? ` (your rule ${rule})` : ''}`}
    >
      <Icon aria-hidden="true" className="size-3" />
      {priorityLabel(priority)}
    </Badge>
  )
}
